/* ============================================
   AANYA Performance Utilities
   Lazy load observer, LQIP handler, fetch priority hints
   Include once in theme.liquid
   ============================================ */

(function () {
  /* Lazy load images with data-src */
  if ('IntersectionObserver' in window) {
    var imgObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
              img.removeAttribute('data-srcset');
            }
            img.classList.add('aanya-loaded');
            imgObserver.unobserve(img);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    document.querySelectorAll('img[data-src]').forEach(function (img) {
      imgObserver.observe(img);
    });
  }

  /* Preload critical routes on hover */
  document.querySelectorAll('a[href^="/"]').forEach(function (a) {
    var timeout;
    a.addEventListener('mouseenter', function () {
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = a.href;
      link.as = 'document';
      timeout = setTimeout(function () {
        document.head.appendChild(link);
      }, 150);
    });
    a.addEventListener('mouseleave', function () {
      clearTimeout(timeout);
    });
  });

  /* Defer non-critical CSS */
  document.querySelectorAll('link[media="print"]').forEach(function (link) {
    link.media = 'all';
  });

  /* Warm up third-party origins */
  ['https://wa.me', 'https://fonts.googleapis.com'].forEach(function (origin) {
    var link = document.createElement('link');
    link.rel = 'dns-prefetch';
    link.href = origin;
    document.head.appendChild(link);
  });
})();
